import { useHeroParallax } from '@/hooks/useHeroParallax';
import s from './SubPageHero.module.scss';

// 서브페이지 공통 히어로 — evs.com/applications/* 스타일(정지 이미지 풀블리드 + 하단좌측 큰 흰 제목).
//   목업(corporate-events)엔 mp4 대신 정지 이미지. 이미지는 목업 것을 그대로 사용(추후 EVS용으로 교체) — 사용자 2026-08-02.
//   breadcrumb는 선택(HOME > 상위 > 현재).
interface Crumb { label: string; }
interface Props {
  title: string;
  subtitle?: string;   // 슬로건 보조라인(국문 등)
  image: string;
  crumbs?: Crumb[];
  align?: 'left' | 'center'; // [2026-10-11 사용자] 슬로건 정렬. 기본 center(전역 통일 — 히어로 장식이미지 빈공간 최소화). 회사소개·계정 페이지만 'left'.
  dim?: boolean; // [2026-10-11 사용자] 밝은 히어로 이미지에서 중앙 슬로건이 묻힐 때 중앙까지 어둡게(설치안내 hero-install 등). 기본 off.
}

export default function SubPageHero({ title, subtitle, image, crumbs, align = 'center', dim = false }: Props) {
  // [2026-09-09 사용자] 서브페이지 히어로 이미지에 절제된 스크롤 패럴랙스(다른 히어로와 통일).
  //   래퍼에 패럴랙스(scale+translate) / 이미지에 로드 줌 → transform 충돌 없이 둘 다 유지.
  const bgRef = useHeroParallax<HTMLDivElement>({ factor: 0.12 });
  return (
    <section className={s.hero}>
      <div ref={bgRef} className={s.bgWrap}>
        <img className={s.bg} src={image} alt="" aria-hidden />
      </div>
      <div className={`${s.shade} ${dim ? s.shadeDim : ''}`} aria-hidden />

      {/* 현재 위치 표기(breadcrumb) — 목업 evs.com/applications 방식: 히어로 상단 좌측, 헤더 아래.
          앞 항목=흰색 링크, 마지막(현재)=흰색 딤(0.5). 로드 시 페이드업(스태거). */}
      {crumbs && crumbs.length > 0 && (
        <nav className={s.crumbsBar} aria-label="현재 위치">
          {crumbs.map((c, i) => {
            const isCurrent = i === crumbs.length - 1;
            return (
              <span key={c.label} className={s.crumbItem}>
                {i > 0 && <span className={s.sep} aria-hidden>›</span>}
                {isCurrent
                  ? <span className={s.current} aria-current="page">{c.label}</span>
                  : <a href="#" className={s.crumbLink} onClick={(e) => e.preventDefault()}>{c.label}</a>}
              </span>
            );
          })}
        </nav>
      )}

      <div className={`${s.inner} ${align === 'center' ? s.center : ''}`}>
        <h1 className={s.title}>{title}</h1>
        {subtitle && <p className={s.subtitle}>{subtitle}</p>}
      </div>
    </section>
  );
}
